<template>
  <footer v-if="visible" class="page-footer" :class="footerClass">
    <section class="footer-container">
      <div class="content">
        <div class="info-item">
          <div class="title">{{ $cms('c_a0eb554e1929', 'f_0001', "售后专线") }}</div>
          <span class="text">{{ $cms('c_a0eb554e1929', 'f_0002', "售后专线：400-900-1231") }}</span>
          <span class="text"><a :href="$cms('c_a0eb554e1929', 'f_0003', &quot;mailto:kf@moukuai.com&quot;)" class="email"
              >{{ $cms('c_a0eb554e1929', 'f_0004', "售后邮箱：kf@moukuai.com") }}</a
            ></span>
          <span class="text">{{ $cms('c_a0eb554e1929', 'f_0005', "服务时间 工作日 9:00-18:00") }}</span>
        </div>
        <div class="info-item">
          <div class="title">{{ $cms('c_a0eb554e1929', 'f_0006', "联系我们") }}</div>
          <span class="text">
            <a :href="$cms('c_a0eb554e1929', 'f_0007', &quot;mailto:hz@mockuai.com&quot;)" class="email"
              >{{ $cms('c_a0eb554e1929', 'f_0008', "官方合作：hz@mockuai.com") }}</a
            >
          </span>
          <span class="text">{{ $cms('c_a0eb554e1929', 'f_0009', "总部地址：浙江省杭州市余杭区龙泉路20号") }}</span>
        </div>
        <div class="info-item">
          <div class="title">{{ $cms('c_a0eb554e1929', 'f_0010', "加入我们") }}</div>
          <span class="text">
            <a :href="$cms('c_a0eb554e1929', 'f_0011', &quot;/join-us&quot;)" style="text-decoration: underline;"
              >{{ $cms('c_a0eb554e1929', 'f_0012', "了解魔筷") }}</a
            >
          </span>
          <span class="text">
            <a :href="$cms('c_a0eb554e1929', 'f_0013', &quot;mailto:hr@mockuai.com&quot;)" class="email"
              >{{ $cms('c_a0eb554e1929', 'f_0014', "简历投递：hr@mockuai.com") }}</a
            >
          </span>
        </div>
        <div class="qrcode">
          <div class="qrcode-item">
            <img
:src="$cms('c_a0eb554e1929', 'f_0015', &quot;https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250910172620170000214.17574963799598162.png&quot;)"
              alt=""
              class="icon"
            />
            <img
:src="$cms('c_a0eb554e1929', 'f_0016', &quot;https://mk-crm-cdn.mockuai.com/home/1723083617476681923.jpg&quot;)"
              alt=""
              class="code"
            />
          </div>
          <div class="qrcode-item">
            <img
:src="$cms('c_a0eb554e1929', 'f_0017', &quot;https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250910172620170000890.17574963799583425.png&quot;)"
              alt=""
              class="icon"
            />
            <img
:src="$cms('c_a0eb554e1929', 'f_0018', &quot;https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250910100703860000262.17574700235441353.jpg&quot;)"
              alt=""
              class="code"
            />
          </div>
          <div class="qrcode-item">
            <img
:src="$cms('c_a0eb554e1929', 'f_0019', &quot;https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250910172620170000972.17574963799561177.png&quot;)"
              alt=""
              class="icon"
            />
            <img
:src="$cms('c_a0eb554e1929', 'f_0020', &quot;https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250910100739380000344.17574700592342408.jpg&quot;)"
              alt=""
              class="code"
            />
          </div>
        </div>
      </div>

      <div class="info">
        <div class="item">
          <span
            >{{ $cms('c_a0eb554e1929', 'f_0021', "©2015-2025 Mockuai.com\n            杭州魔筷科技有限公司（杭州次元岛科技有限公司系魔筷全资子公司）") }}</span
          >
        </div>
        <div class="item">
          <span style="margin-right: 15px">{{ $cms('c_a0eb554e1929', 'f_0022', "魔筷科技V3.1.2") }}</span>
          <a
            target="__blank"
:href="$cms('c_a0eb554e1929', 'f_0023', &quot;https://act.mockuai.com/m/3c2c33b405044508397639dc649d13cd.html&quot;)"
          >
            {{ $cms('c_a0eb554e1929', 'f_0024', "应用权限") }}
          </a>
          <a target="__blank" :href="$cms('c_a0eb554e1929', 'f_0025', &quot;https://cdn.mockuai.com/tms/7886.html&quot;)">
            {{ $cms('c_a0eb554e1929', 'f_0026', "隐私权政策") }}
          </a>
          <a
            target="__blank"
:href="$cms('c_a0eb554e1929', 'f_0027', &quot;https://mktv-in-cdn.mockuai.com/16024961508525175.png&quot;)"
          >
            {{ $cms('c_a0eb554e1929', 'f_0028', "信息系统安全等级保护（三级）") }}
          </a>
          <a
            target="__blank"
:href="$cms('c_a0eb554e1929', 'f_0029', &quot;https://cdn.mockuai.com/tms/27001zs_edit.pdf&quot;)"
          >
            {{ $cms('c_a0eb554e1929', 'f_0030', "ISO27001信息安全管理体系认证") }}
          </a>
          <a target="__blank" :href="$cms('c_a0eb554e1929', 'f_0031', &quot;https://cdn.mockuai.com/tms/47307.pdf&quot;)">
            {{ $cms('c_a0eb554e1929', 'f_0032', "网络食品交易管理承诺书") }}
          </a>
          <a
            style="cursor: pointer"
@click="
              open(
                $cms('c_a0eb554e1929', 'f_0033', &quot;https://pc-helper.mockuai.com/?app_type=30&amp;channel_id=1&amp;page_id=15&amp;tag=2&quot;)
              )
            "
          >
            {{ $cms('c_a0eb554e1929', 'f_0034', "SaaS规则中心") }}
          </a>
          <a
            style="cursor: pointer"
@click="
              open(
                $cms('c_a0eb554e1929', 'f_0035', &quot;https://pc-helper.mockuai.com/?app_type=30&amp;channel_id=1&amp;page_id=14&amp;tag=1&quot;)
              )
            "
          >
            {{ $cms('c_a0eb554e1929', 'f_0036', "供应商规则中心") }}
          </a>
          <a
            style="cursor: pointer"
@click="open($cms('c_a0eb554e1929', 'f_0037', &quot;https://www.mockuai.com/intellectual-property&quot;))"
          >
            {{ $cms('c_a0eb554e1929', 'f_0038', "知识产权") }}
          </a>
        </div>
        <div class="item">
          <span style="margin-right: 15px"
            >{{ $cms('c_a0eb554e1929', 'f_0039', "违法和不良信息及算法推荐专项举报电话：400-900-1231") }}</span
          >
          <span>{{ $cms('c_a0eb554e1929', 'f_0040', "邮箱：weijinjubao@mockuai.com") }}</span>
        </div>
        <div class="item">
          <span style="margin-right: 15px"
            >{{ $cms('c_a0eb554e1929', 'f_0041', "增值电信业务经营许可证：浙B2-20180636 -") }}
            <a :href="$cms('c_a0eb554e1929', 'f_0042', &quot;https://beian.miit.gov.cn&quot;)">{{ $cms('c_a0eb554e1929', 'f_0043', "浙ICP备15018042号-6") }}</a>
            {{ $cms('c_a0eb554e1929', 'f_0044', "浙网食A3300100015 新出发浙备字第2020001号\n            （浙）网械平台备字【2020】第00014号") }}</span
          >
          <a
            class="police"
            target="_blank"
:href="$cms('c_a0eb554e1929', 'f_0045', &quot;http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33010602004760&quot;)"
          >
            <img
:src="$cms('c_a0eb554e1929', 'f_0046', &quot;https://mktv-in-cdn.mockuai.com/16359274165654253.png&quot;)"
              alt=""
              class="item_ico"
            />
            {{ $cms('c_a0eb554e1929', 'f_0047', "浙公网安备 33010602004760号") }}</a
          >
        </div>
        <div class="item"><a class="police" :href="$cms('c_a0eb554e1929', 'f_0048', &quot;https://mktv-in.oss-cn-hangzhou.aliyuncs.com/open_file2023101221115574900018604.pdf&quot;)">{{ $cms('c_a0eb554e1929', 'f_0049', "魔筷营业执照") }}</a></div>
      </div>
    </section>
  </footer>
</template>

<script>
export default {
  props: {
    theme: {
      type: String,
      default: "normal",
    },
    type: {
      type: String,
      default: "layout",
    },
  },
  computed: {
    footerClass() {
      return this.theme === "transparent" ? "bg-trans" : "";
    },
    visible() {
      if (this.type === "layout") {
        
        const { withoutLayout, withoutFooter } = this.$route.meta;
        console.log('withoutLayout, withoutFooter', withoutLayout, withoutFooter)
        return !withoutLayout && !withoutFooter;
      } else {
        return true;
      }
    },
  },
  mounted() {
    console.log("footer mounted", this.$route.meta.withoutLayout);
  },
  methods: {
    open(url) {
      window.open(url);
    },
  },
};
</script>

<style lang="less" scoped>
.page-footer {
  box-sizing: border-box;
  // position: fixed;
  // left: 0;
  // bottom: 0;
  width: 100%;
  overflow: hidden;
  background-color: #00092a;

  a {
    color: #fff;
    text-decoration: none;
    &:hover {
      text-decoration: none;
    }
  }
  
  &.bg-trans {
    background-color: transparent;
  }
  .footer-container {
    margin: 0 auto;
    min-width: 960px;
    color: #fff;
    .content {
      display: flex;
      justify-content: center;
      padding-top: 52px;
      padding-bottom: 46px;
      .list {
        display: flex;
        flex-direction: column;
        gap: 36px;
        justify-content: space-between;
        margin-right: 60px;
        margin-top: 6px;
        .item {
          cursor: pointer;
          font-weight: 500;
          font-size: 16px;
          color: #FFFFFF;
          line-height: 22px;
        }
      }
      .info-item {
        display: flex;
        flex-direction: column;
        margin-right: 60px;
        .title {
          margin-bottom: 31px;
          font-size: 20px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          line-height: 28px;
        }
        .text {
          text-decoration: none;
          color: #fff;
          margin-bottom: 33px;
          font-size: 14px;
          font-family: PingFangSC-Light, PingFang SC;
          font-weight: 300;
          line-height: 20px;
          opacity: 0.8;
          &:last-child {
            margin-bottom: 0;
          }
        }
      }
      .qrcode {
        display: flex;
        .qrcode-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          margin-right: 18px;
          .icon {
            height: 20px;
            object-fit: cover;
          }
          .code {
            width: 104px;
            height: 104px;
            margin-top: 12px;
          }
        }
      }
    }
    .info {
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-top: 50px;
      padding-bottom: 50px;
      &::before {
        content: "";
        position: absolute;
        top: 0;
        left: -100%;
        width: 10000px;
        height: 1px;
        background-color: #999;
        opacity: 0.3;
      }
      .item {
        font-size: 14px;
        line-height: 30px;
        opacity: 0.8;
        display: flex;
        .police {
          display: flex;
          align-items: center;
        }
        .item_ico {
          width: 20px;
          height: 20px;
          display: block;
          margin-right: 5px;
        }
        span {
          opacity: inherit;
        }
        a {
          margin-right: 15px;
          color: #fff;
          opacity: inherit;
          text-decoration: none;
          &:last-child {
            margin-right: 0;
          }
        }
      }
    }
  }
}
@media screen and(max-width: 1200px) {
  .page-footer {
    overflow: auto;
    .content {
      .consult {
        margin-right: 30px;
      }
      .info-item {
        margin-right: 20px;
      }
    }
  }
}
@media screen and(min-width: 1200px) and(max-width: 1640px) {
  .page-footer {
    .footer-container {
      width: 1440px;
      .content {
        .consult {
          margin-right: 120px;
        }
        .info-item {
          margin-right: 80px;
        }
      }
    }
  }
}
@media screen and (min-width: 1640px) {
  .page-footer {
    .footer-container {
      width: 1440px;
      .content {
        .consult {
          margin-right: 200px;
        }
        .info-item {
          margin-right: 80px;
        }
      }
    }
  }
}
</style>
